export enum AccessorialImportType {
  ORIGINAL = "ORIGINAL",
  SPECIAL = "SPECIAL",
  ZONE_BASED = "ZONE_BASED",
}
